import { render, staticRenderFns } from "./ScwlWaybillMonthChartOther.vue?vue&type=template&id=285a37b6&scoped=true"
import script from "./ScwlWaybillMonthChartOther.vue?vue&type=script&lang=js"
export * from "./ScwlWaybillMonthChartOther.vue?vue&type=script&lang=js"
import style0 from "./ScwlWaybillMonthChartOther.vue?vue&type=style&index=0&id=285a37b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a37b6",
  null
  
)

export default component.exports